import { useQuery } from "@tanstack/react-query";

import {
  IAppointment,
  IGetAppointmentsListRequest,
} from "../../@types/Appointment";
import { appointmentsService } from "../../services/appointmentsService";

export function getUserAppointmentsData(request: IGetAppointmentsListRequest) {
  const { data, isFetching, isError, refetch, isRefetching } = useQuery<
    IAppointment[]
  >({
    queryKey: [
      "table-user-appointments",
      request.patientId ?? "all",
      request.startDate,
      request.endDate,
    ],
    queryFn: async () => {
      const { data } = await appointmentsService.getUserAppointments(request);

      return data;
    },
  });

  // Note: `date` is kept as the raw ISO string here. The table formats it for
  // display and relies on the raw value for its date logic (join/disable).
  return {
    appointments: data,
    isFetching,
    isError,
    refetch,
    isRefetching,
  };
}
